import React from 'react';
import { XIcon, SearchIcon, MapPinIcon, HeartIcon, UserIcon, PhoneIcon } from 'lucide-react';
interface MobileMenuProps {
  isOpen: boolean;
  onClose: () => void;
  onNavigate: (page: 'home' | 'shop' | 'product') => void;
}
export function MobileMenu({
  isOpen,
  onClose,
  onNavigate
}: MobileMenuProps) {
  if (!isOpen) return null;
  const handleNav = (page: 'home' | 'shop' | 'product') => {
    onNavigate(page);
    onClose();
  };
  return <div className="fixed inset-0 z-50 flex" data-id="element-533">
      <div className="absolute inset-0 bg-slate-900/50 backdrop-blur-sm transition-opacity animate-fade-in" onClick={onClose} data-id="element-534" />

      <div className="relative w-4/5 max-w-sm bg-white h-full shadow-2xl flex flex-col animate-slide-in-right" data-id="element-535">
        {/* Header */}
        <div className="flex items-center justify-between p-4 border-b border-gray-100" data-id="element-536">
          <img src="https://cdn.magicpatterns.com/uploads/sh7d1L5p7P4qM7QsZEZJDX/logo-header.png" alt="Better Pets and Gardens" className="h-8 object-contain" data-id="element-537" />
          <button onClick={onClose} className="p-2 text-gray-400 hover:text-gray-600 hover:bg-gray-100 rounded-full transition-colors" data-id="element-538">
            <XIcon className="w-6 h-6" data-id="element-539" />
          </button>
        </div>

        {/* Content */}
        <div className="flex-1 overflow-y-auto" data-id="element-540">
          {/* Search */}
          <div className="p-4 border-b border-gray-100" data-id="element-541">
            <div className="relative" data-id="element-542">
              <input type="text" placeholder="Search products..." className="w-full bg-warm-50 border border-gray-200 rounded-xl py-3 pl-10 pr-4 text-gray-900 focus:outline-none focus:border-brand-blue" data-id="element-543" />
              <SearchIcon className="absolute left-3 top-1/2 -translate-y-1/2 w-5 h-5 text-gray-400" data-id="element-544" />
            </div>
          </div>

          {/* Store Selector */}
          <div className="p-4 border-b border-gray-100 bg-brand-blue-50/50" data-id="element-545">
            <div className="flex items-center gap-3" data-id="element-546">
              <div className="w-10 h-10 rounded-full bg-white shadow-sm flex items-center justify-center text-brand-blue" data-id="element-547">
                <MapPinIcon className="w-5 h-5" data-id="element-548" />
              </div>
              <div data-id="element-549">
                <div className="text-xs text-gray-500 font-medium" data-id="element-550">
                  Your Store
                </div>
                <div className="text-sm font-heading font-bold text-gray-900" data-id="element-551">
                  Select a Store
                </div>
              </div>
            </div>
          </div>

          {/* Main Nav */}
          <nav className="p-4 border-b border-gray-100" data-id="element-552">
            <ul className="space-y-1" data-id="element-553">
              <li data-id="element-554">
                <button onClick={() => handleNav('shop')} className="w-full flex items-center justify-between py-3 px-2 text-left font-heading font-semibold text-gray-900 hover:bg-gray-50 rounded-lg" data-id="element-555">
                  Shop Pets
                </button>
              </li>
              <li data-id="element-556">
                <button onClick={() => handleNav('shop')} className="w-full flex items-center justify-between py-3 px-2 text-left font-heading font-semibold text-gray-900 hover:bg-gray-50 rounded-lg" data-id="element-557">
                  Shop Garden
                </button>
              </li>
              <li data-id="element-558">
                <button onClick={() => handleNav('shop')} className="w-full flex items-center justify-between py-3 px-2 text-left font-heading font-semibold text-gray-900 hover:bg-gray-50 rounded-lg" data-id="element-559">
                  Shop Pools & Spas
                </button>
              </li>
              <li data-id="element-560">
                <button className="w-full flex items-center justify-between py-3 px-2 text-left font-heading font-semibold text-red-600 hover:bg-red-50 rounded-lg" data-id="element-561">
                  Specials
                </button>
              </li>
              <li data-id="element-562">
                <button className="w-full flex items-center justify-between py-3 px-2 text-left font-heading font-semibold text-gray-900 hover:bg-gray-50 rounded-lg" data-id="element-563">
                  Stores
                </button>
              </li>
              <li data-id="element-564">
                <button className="w-full flex items-center justify-between py-3 px-2 text-left font-heading font-semibold text-gray-900 hover:bg-gray-50 rounded-lg" data-id="element-565">
                  Advice
                </button>
              </li>
            </ul>
          </nav>

          {/* Secondary Nav */}
          <div className="p-4 space-y-4" data-id="element-566">
            <button className="w-full flex items-center gap-3 py-2 px-2 text-left font-medium text-gray-700 hover:bg-gray-50 rounded-lg" data-id="element-567">
              <UserIcon className="w-5 h-5 text-gray-400" data-id="element-568" />
              Sign In / Register
            </button>
            <button className="w-full flex items-center gap-3 py-2 px-2 text-left font-medium text-brand-blue hover:bg-brand-blue-50 rounded-lg" data-id="element-569">
              <HeartIcon className="w-5 h-5" data-id="element-570" />
              Customer Care Club
            </button>
          </div>
        </div>

        {/* Footer CTA */}
        <div className="p-4 border-t border-gray-100 bg-warm-50" data-id="element-571">
          <button className="w-full flex items-center justify-center gap-2 bg-white border border-gray-200 text-gray-800 font-heading font-semibold py-3 rounded-xl shadow-sm" data-id="element-572">
            <PhoneIcon className="w-5 h-5" data-id="element-573" />
            Call Your Store
          </button>
        </div>
      </div>
    </div>;
}